module.exports = __webpack_public_path__ + "static/img/title.3e71d18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title.png
// module id = Cb4U
// module chunks = 2